import React from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import UserDashboardSidebar from '../Common/Layout/UserDashboardSidebar';
import { useAuth } from '../Common/Configurations/AuthContext';
import './AccountLayout.css';

const AccountLayout = () => {
    const { user } = useAuth();

    if (!user) {
        return <Navigate to="/" replace />;
    }

    return (
        // 3. New two-column layout structure
        <div className="account-layout-wrapper">
            <UserDashboardSidebar />
            <main className="account-content">
                <Outlet />
            </main>
        </div>
    );
};

export default AccountLayout;